import { render } from "./holiday.vue?vue&type=template&id=3b9837fc"
import script from "./holiday.vue?vue&type=script&lang=js"
export * from "./holiday.vue?vue&type=script&lang=js"

import "./holiday.vue?vue&type=style&index=0&id=3b9837fc&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__